import { SlideFileUploadIcon, SlideFileUploadLink } from '../../atoms';

interface Props {
    isDragActive: boolean;
}

export const SlideFileUpload = ({ isDragActive }:Props) => (
    <>
        <SlideFileUploadIcon />
        <SlideFileUploadLink isDragActive={isDragActive} />
    </>
);
